import React from "react";
import PropTypes from "prop-types";
import ti18n from 'i18n!nls/Sequenceri18n';
import SequencerSearchWidget from "../models/audioEditor/SequencerSearchWidget";

// Import specific parameter components
import EditorSearchParamsForSilenceSearch from "./EditorSearchParamsForSilenceSearch";
import EditorSearchParamsForSilenceRadio from "./EditorSearchParamsForSilenceRadio";    


const SEARCH_TYPE = SequencerSearchWidget.SEARCH_TYPE;

const EditorSearchParams = ({ 
    searchType, 
    searchParams, 
    onSearchParamsChange,
    searchWidgetModel,
    isAnalyzing = false
}) => {
    // Render different parameter configurations based on search type
    const renderSearchParamsComponent = () => {
        switch (searchType) {
            case SEARCH_TYPE.SILENCES:
                return (
                    <EditorSearchParamsForSilenceRadio
                        searchParams={searchParams}
                        onSearchParamsChange={onSearchParamsChange}
                        searchWidgetModel={searchWidgetModel}
                        isAnalyzing={isAnalyzing}
                    />
                );
            
            case SEARCH_TYPE.TEXT_SEARCH:
            case SEARCH_TYPE.SEMANTIC_SEARCH:
            case SEARCH_TYPE.FILLER_WORDS:
            case SEARCH_TYPE.EDIT_BOUNDARIES:
            case SEARCH_TYPE.AI_EDIT_SUGGESTIONS:
            case SEARCH_TYPE.DISFLUENCY_SEARCH:
            default:
                // Return null for search types that don't support parameters
                return null;
        }
    };

    const paramsComponent = renderSearchParamsComponent();
    
    // Don't render anything if no parameters are supported for this search type
    if (!paramsComponent) {
        return null;
    }

    return (
        <div className="mb-3">
            <div className="text-sm font-medium text-gray-700 mb-2">
                {window.getI18n(ti18n, "SEARCH_PARAMETERS")}
            </div>
            {paramsComponent}
        </div>
    );
};

EditorSearchParams.propTypes = {
    searchType: PropTypes.string,
    searchParams: PropTypes.object,
    onSearchParamsChange: PropTypes.func,
    searchWidgetModel: PropTypes.object,
    isAnalyzing: PropTypes.bool
};

export default EditorSearchParams; 